import { ImageFit, PanelType, SelectionMode } from "@fluentui/react";
import { Guid } from "@ioip/core/lib";
import { DataSourceType } from "../../datasources";
import { IFlowData } from "../../flow/components/IFlowData";
import { PermissionLevel } from "../../studio-types";
import { ControlType, IFilter } from "../../types";
import { IDataTableColumnSchema } from "../../types/IDataTableColumn";

export interface IFieldSchema {
    attributeId?: string;
    controlType: ControlType;
    id: string;
    ignoreChanges?: boolean;
    name?: string;
    title?: string;
    activity?: string;
    order: number;
    parentId?: string;
    version?: number;
    // Layout
    colSm?: number;
    colMd?: number;
    colLg?: number;
    colXl?: number;
    colXxl?: number;
    colXxxl?: number;
    // New
    columns?: IDataTableColumnSchema[];
    visible?: boolean;
    visibleRule?: IFlowData;
    required?: boolean;
    requiredRule?: IFlowData;
    disabled?: boolean;
    disabledRule?: IFlowData;
    readonly?: boolean;
    readonlyRule?: IFlowData;
    label?: string;
    placeholder?: string;
    maxLength?: number;
    minLength?: number;
    maxValue?: string;
    multiline?: boolean;
    minValue?: string;
    minDate?: Date;
    maxDate?: Date;
    minItems?: number;
    maxItems?: number;
    pattern?: string;
    filter?: IFilter;
    style?: {
        foreColor?: string;
        backColor?: string;
        fontSize?: number;
    };
    locked?: boolean;
    url?: string;
    width?: string;
    height?: string;
    formId?: string; // Almacena el ID del formulario asociado al control DataTable
    panelTitle?: string;
    calculatedValue?: IFlowData;
    dataSourceType?: DataSourceType;
    dataSourceEntityId?: string;
    dataSourceEntityViewId?: string;
    selectionMode?: SelectionMode;
    panelType?: PanelType;
    previewImageSrc?: string;
    iconSrc?: string;
    imageFit?: ImageFit;
    permissionLevel?: PermissionLevel;
    help?: string;
    showAsSecondaryTitle?: boolean;
}

export const defaultIFieldSchema = (controlType: ControlType): IFieldSchema => ({
    id: Guid.newGuid().toString(),
    controlType,
    name: "",
    order: 0
});





